import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

const ConfirmDialog = ({
  heading,  
  message,
  open,
  handleClose,
  handleConfirm,
  loading
}) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={handleClose}>
      <DialogTitle>{heading}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          disabled={loading}
          variant="contained"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button color="primary" variant="outlined" onClick={handleConfirm}>
          {loading ? <>Loading...</> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
